// TYPES #############################################################
import { ArchivingContractTypeEnum } from '@app/modules/contract/models/contract.model';

export type ArchivingEntityUsageType =
	ArchivingContractUsage;


export type ArchivingEntityDataUsageType =
	ArchivingContractDataUsage;

export type ArchivingDataUsageDetailProp = ( keyof ArchivingDataUsageDetail );

export type ArchivingDataUsageDetailProps = ArchivingDataUsageDetailProp[];

export type ArchivingDataUsageProp = ( keyof ArchivingDataUsage );

export type ArchivingDataUsageProps = ArchivingDataUsageProp[];


// ENTITIES ##########################################################
// MODEL USED FOR TRANSITION APP<->API (TransitionalModelObject)
// Usage
export class ArchivingUsageErsActivatedPerMonthTMO {
	month?: number = undefined;
	total?: number = undefined;
}

export class ArchivingUsageErsPriceTMO {
	billingTier?: number = undefined;
	total?: number = undefined;
}

export class ArchivingUsageExternalErsPriceTMO {
	billingTier?: number = undefined;
	total?: number = undefined;
}

export class ArchivingUsageTMO {
	activated?: ArchivingUsageErsActivatedPerMonth[] = undefined;
	billable?: ArchivingUsageErsPrice[] = undefined;
	billableExternal?: ArchivingUsageExternalErsPrice[] = undefined;
	total?: number = undefined;
	totalExternal?: number = undefined;
	year?: number = undefined;
}

export class ArchivingUsageBaseTMO {
	usage?: ArchivingUsage = undefined;
}


// TODO uncomment when one of the other entity usages are needed
// export class ArchivingBusinessPremisesUsageTMO extends ArchivingUsageBaseTMO {}

export class ArchivingContractUsageTMO extends ArchivingUsageBaseTMO {
	contractId?: string = undefined;
}

// export class ArchivingOrganizationUsageTMO extends ArchivingUsageBaseTMO {}
// export class ArchivingTenantUsageTMO extends ArchivingUsageBaseTMO {}

// DataUsage
export class ArchivingContractDataUsageBaseTMO {
	contracts?: ArchivingTenantDataUsage[] = undefined;
}


export class ArchivingDataUsageDetailTMO {
	cashPointClosing?: number = undefined;
	openArchive?: number = undefined;
	proceduralDocumentation?: number = undefined;
	tssLog?: number = undefined;
}

export class ArchivingDataUsageTMO {
	total?: number = undefined;
	prepaid?: number = undefined;
	usageDetail?: ArchivingDataUsageDetail = undefined;
}

export class ArchivingTenantDataUsageTMO {
	contractId?: string = undefined;
	download?: ArchivingDataUsage = undefined;
	highestContractType?: ArchivingContractTypeEnum = undefined;
	storage?: ArchivingDataUsage = undefined;
	tenantId?: string = undefined;
}


// TODO uncomment when one of the other entity usages are needed
// export class ArchivingBusinessPremisesDataUsageTMO {}
export class ArchivingContractDataUsageTMO extends ArchivingContractDataUsageBaseTMO {}

// export class ArchivingOrganizationDataUsage {}
// export class ArchivingTenantDataUsage extends {}

// MODEL USED IN APPLICATION (with additional properties)
// Usage
export class ArchivingUsageErsActivatedPerMonth extends ArchivingUsageErsActivatedPerMonthTMO {}

export class ArchivingUsageErsPrice extends ArchivingUsageErsPriceTMO {}

export class ArchivingUsageExternalErsPrice extends ArchivingUsageExternalErsPriceTMO {}

export class ArchivingUsage extends ArchivingUsageTMO {}


// TODO uncomment when one of the other entity usages are needed
// export class ArchivingBusinessPremisesUsage extends ArchivingBusinessPremisesUsageTMO {}

export class ArchivingContractUsage extends ArchivingContractUsageTMO {}

// export class ArchivingOrganizationUsage extends ArchivingOrganizationrUsageTMO {}
// export class ArchivingTenantUsage extends ArchivingTenantUsageTMO {}

// DataUsage
export class ArchivingDataUsageDetail extends ArchivingDataUsageDetailTMO {}

export class ArchivingDataUsage extends ArchivingDataUsageTMO {}

export class ArchivingTenantDataUsage extends ArchivingTenantDataUsageTMO {}


// TODO uncomment when one of the other entity usages are needed
// export class ArchivingBusinessPremisesDataUsage extends ArchivingBusinessPremisesDataUsageTMO {}

export class ArchivingContractDataUsage extends ArchivingContractDataUsageTMO {}

// export class ArchivingOrganizationDataUsage extends ArchivingOrganizationDataUsageTMO {}
// export class ArchivingTenantDataUsage extends ArchivingTenantDataUsageTMO {}
